export type Seller = {
    address: string;
    address2: string;
    /**
     * Compared to `name` or `alias`, which represent Jasper52/Chairish/etc.,
     * this refers to the individual seller's name.
     */
    agentName: string;
    alias: string;
    betas: number[];
    city: string;
    country: string;
    countryCode: string;
    createdDate?: string;
    globalATGId: string;
    logoId: string;
    /**
     * The name of the seller house, which will likely by Jasper52 or Chairish.
     */
    name: string;
    regionCode: string;
    sellerId: number;
    stateCode: string;
    stateName: string;
    zip: string;
};

export const EmptySeller: Seller = {
    address: '',
    address2: '',
    agentName: '',
    alias: '',
    betas: [],
    city: '',
    country: '',
    countryCode: '',
    globalATGId: '',
    logoId: '',
    name: '',
    regionCode: '',
    sellerId: 0,
    stateCode: '',
    stateName: '',
    zip: '',
};
